import { authRestoreToken } from '../app/shared/utils';
import { WebSocketLink } from '@apollo/client/link/ws';
import { ConfigService } from '../app/shared/services/config/config.service';

export function createWsClient(configService: ConfigService): WebSocketLink {
  return new WebSocketLink({
    uri: configService.config.apollo.subscriptionsUrl,
    options: {
      reconnect: true,
      connectionParams: () => {
        const authData = authRestoreToken();
        if (!authData) {
          return {};
        }
        const authToken = authData.token;
        if (authToken) {
          return {
            authToken,
          };
        }
        return {};
      },
    },
  });
}
